import produce from '../utils/produce'

export const initialState = {
    isLogin: false,
    userInfo: null,
}

export const LOG_IN_REQUEST = 'LOG_IN_REQUEST'
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'
export const LOG_IN_FAILURE = 'LOG_IN_FAILURE'

export default (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case LOG_IN_REQUEST: {
                break
            }
            case LOG_IN_SUCCESS: {
                draft.isLogin = action.data.isLogin
                draft.userInfo = action.data.isLogin ? action.data.result : null
                break
            }
            case LOG_IN_FAILURE: {
                break
            }
            default: {
                break
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/estimate_list/reducers/user.js